module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('Navs'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "col-md-12",
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('vue-particles', {
    attrs: {
      "color": "#1d3557",
      "particleOpacity": 0.4,
      "particlesNumber": 45,
      "shapeType": "star",
      "particleSize": 4,
      "linesColor": "#05668d",
      "linesWidth": 1,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "hoverEffect": false,
      "hoverMode": "grab",
      "clickMode": "push"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fullPage"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticClass: "title-text col-md-12"
  }, [_vm._v("WorkTeen")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5'), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "line-height": "1.1"
    }
  }, [_vm._v("Connecting people to opportunities. Search for "), _c('vue-typer', {
    attrs: {
      "text": ["Intern", "Volunteer", "Mumbai", "Food", "Media", "Teaching", "Computers", "Bangalore", "Design", "Write"],
      "repeat": Infinity,
      "shuffle": false,
      "initial-action": "typing",
      "pre-type-delay": 70,
      "type-delay": 70,
      "pre-erase-delay": 2000,
      "erase-delay": 250,
      "erase-style": "select-all",
      "erase-on-complete": false,
      "caret-animation": "blink"
    }
  })], 1)]), _vm._v(" "), _c('Search')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {}
  }, [_c('Featured')], 1)]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cf6ea1b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 897
// module chunks = 1